import SharedMessagesV2  from "@/components/shared/Messages";

export default function BrokerMessages() {
  return <SharedMessagesV2 role="broker" />;
}